import {
  InternalApiCurrentUserOrganisationCurrencyEnum,
  InternalApiTransaction,
  InternalApiTransactionRelatedPerson,
} from '../api-internal';
import RelatedPersonLink from './RelatedPersonLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong, faArrowLeftLong } from '@fortawesome/pro-regular-svg-icons';
import React, { useMemo } from 'react';
import './LinksToRelatedPersons.scss';
import { symbolOfCurrency } from '../organisation/helper';
import { Link } from 'react-router';

interface LinksToRelatedPersonsProps {
  transaction: InternalApiTransaction;
  currency: InternalApiCurrentUserOrganisationCurrencyEnum | undefined;
  includeLinkToTrx: boolean;
}

export const LinksToRelatedPersons = ({ transaction, currency, includeLinkToTrx }: LinksToRelatedPersonsProps) => {
  const { customer, relatedPersons, attributes } = transaction;
  const { amount, direction } = attributes;

  const isNotCustomer = (relatedPerson: InternalApiTransactionRelatedPerson) =>
    relatedPerson.personId !== customer?.personId;

  const firstParty = relatedPersons.length === 2 ? customer : relatedPersons.find(isNotCustomer);

  const secondParty =
    relatedPersons.length === 2 ? relatedPersons.find(isNotCustomer) : relatedPersons.filter(isNotCustomer)[1];

  const arrowToTransactionDirection = useMemo(() => {
    if (direction === 'O' && relatedPersons.length === 2)
      return <FontAwesomeIcon icon={faArrowRightLong} className='transaction-direction-arrow' aria-label='sent' />;
    if (direction === 'I' && relatedPersons.length === 2)
      return <FontAwesomeIcon icon={faArrowLeftLong} className='transaction-direction-arrow' aria-label='received' />;
    return <span className='transaction-direction-arrow'>-</span>;
  }, [direction, relatedPersons.length]);

  return (
    <>
      {relatedPersons.length === 3 && customer && (
        <div className='mt-2'>
          <span className='text-secondary me-2'>Service provider:</span>
          <RelatedPersonLink {...customer} />
        </div>
      )}
      <div className='mt-2'>
        <RelatedPersonLink {...(firstParty as InternalApiTransactionRelatedPerson)} />
        {arrowToTransactionDirection}
        {transaction.attributes.amount && (
          <>
            {includeLinkToTrx && (
              <Link className='me-2' to={`/transactions/${transaction.id}`}>
                Trx {transaction.id}
              </Link>
            )}
            <span className='transaction-amount'>
              {amount} {currency && symbolOfCurrency[currency]}
            </span>
            {arrowToTransactionDirection}
          </>
        )}
        <RelatedPersonLink {...(secondParty as InternalApiTransactionRelatedPerson)} />
      </div>
    </>
  );
};

export default LinksToRelatedPersons;
